import { getMediaFiles } from '@/api/media.api';
import { withLoading } from '@/shared';
import type { IFetchMediaFileParams, IMediaFile } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { type MaybeRef, unref } from 'vue';

export const useMediasFile = (queryOpts?: MaybeRef<IFetchMediaFileParams>, enabled: MaybeRef<boolean> = true) => {
    const query = useQuery(
        ['media-file', queryOpts],
        async (): Promise<IMediaFile[]> =>
            withLoading(async () => {
                return getMediaFiles(unref(queryOpts)).then(({ mediaFiles }) => {
                    return mediaFiles;
                });
            }),
        {
            initialData: [],
            enabled: unref(enabled),
        },
    );

    return query;
};
